import { useEffect, useState } from 'react';

import AssignBody from './components/AssignBody';
import Modal2 from 'components/_shared/Modal2';
import VirtualCard from 'components/_shared/PopUp2/components/VirtualCard';
import { DebitCardOptions, DebitCardOption, Homeless } from 'types';

type AssignCardPopUpProps = {
    debitCardOptions: DebitCardOptions[];
    handleModalClick: () => void;
    holder: Homeless;
    intakeEmail?: string;
    photo: string;
    setAssignPopUp?: (assignView: boolean) => void;
    setDebitType: (
        type: 'givecard' | 'pex' | 'virtual-givecard' | null
    ) => void;
    setReplaceView?: (replaceView: boolean) => void;
    usingVirtualCards: boolean;
};

const AssignCardPopUp: React.FC<AssignCardPopUpProps> = ({
    debitCardOptions,
    handleModalClick,
    holder,
    intakeEmail,
    photo,
    setAssignPopUp,
    setDebitType,
    setReplaceView,
    usingVirtualCards
}) => {
    const { card, email, id, name } = holder;
    const [showVirtualCardPopup, setShowVirtualCardPopup] = useState(false);
    const [localCardOptions, setLocalCardOptions] = useState(debitCardOptions);
    
    // if usingVirtualCards
    // - no card assigned
    //      - show givecard/virtual-givecard/pex options
    // - if card assigned and already has either givecard/virtual-givecard
    //      - show givecard/virtual-givecard options
    // if not usingVirtualCards
    // - no card assigned
    //      - show givecard/pex options
    // - if card assigned and already has either givecard
    //      - take straight to givecard assign
    
    useEffect(() => {
        const virtualCardOption: DebitCardOption = {
            asset_color: "715776",
            card_asset: "https://givesafe-dev.s3.amazonaws.com/public/images/card-example-givecard.png",
            friendly_name: "Virtual GiveCard",
            logo_asset: "https://givesafe-dev.s3.amazonaws.com/public/images/logo-givecard.png",
            type: "virtual-givecard",
        }

        let updated = [...debitCardOptions];

        if (usingVirtualCards) {
            const alreadyAdded = updated.some(opt => opt.type === "virtual-givecard");
            if (!alreadyAdded) {
                updated.push(virtualCardOption);
            }
        }

        if (JSON.stringify(updated) !== JSON.stringify(localCardOptions)) {
            setLocalCardOptions(updated);
        }

        // if debitCardOptions is only one set setDebitType to it and setAssignPopUp to true
        if (updated.length === 1){
            setDebitType(updated[0].type)
            if (setReplaceView) {
                setReplaceView(true);
            }
            
            if (setAssignPopUp) {
                setAssignPopUp(false);
            }
        }

    }, [
        usingVirtualCards,
        debitCardOptions,
        card,
        localCardOptions,
        setAssignPopUp,
        setDebitType,
        setReplaceView
    ]);

    const handleUpdateModalClose = () => {
        handleModalClick();
    };

    if (showVirtualCardPopup) {
        return (
            <VirtualCard
                email={email ?? intakeEmail!}
                handleClose={handleUpdateModalClose}
                id={id}
                name={name}
            />
        )
    }

    return (
        <>
            <Modal2 onClose={handleUpdateModalClose} title="Assign Card">
                <AssignBody
                    debitCardOptions={localCardOptions}
                    photo={photo}
                    setAssignPopUp={setAssignPopUp}
                    setDebitType={setDebitType}
                    setReplaceView={setReplaceView}
                    setShowVirtualCardPopup={setShowVirtualCardPopup}
                />
            </Modal2>
        </>
    );
};

export default AssignCardPopUp;
